import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "../../components/ui/card";
import { Tile } from "../../types";
import { useAuth } from "../../contexts/AuthContext";
import { api } from "../../lib/api";

interface TypeTileProps {
  tile: Tile;
  setupMode?: boolean;
  listeners?: React.HTMLAttributes<HTMLElement>;
  attributes?: Record<string, any>;
  updateTileConfig: (id: string, config: Partial<Tile["config"]>) => void;
}

const TypeTile: React.FC<TypeTileProps> = ({
  tile,
  setupMode = false,
  updateTileConfig,
  attributes,
  listeners,
}) => {
  const subtype = tile.config?.subtype || "";
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const userId = user?.uid ?? "";
  const [entries, setEntries] = useState<{ id: string; title: string; purchaseLink: string }[]>([]);

  useEffect(() => {
    const fetchSubtypeItems = async () => {
      if (!subtype || !userId) return;
      setLoading(true);

      try {
        const response = await axios.get(api.getTop10(subtype, userId));
        setEntries(response.data ?? []);
      } catch (error) {
        console.error("Error fetching top 10 books:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubtypeItems();
  }, [subtype, userId]);


  return (
    <Card className="bg-[#E0FFD0] h-full">
      <CardContent className="h-full flex flex-col items-start justify-start space-y-2">
        {setupMode ? (
          <div className="w-full">
            <div className="flex justify-between items-center w-full">
              <h2
                className="text-xl font-semibold drag-handle cursor-move"
                {...attributes}
                {...listeners}
              >
                {tile.title}
              </h2>
            </div>

            <select
              value={subtype}
              onChange={(e) =>
                updateTileConfig(tile.id, { subtype: e.target.value })
              }
              className="p-2 border border-gray-300 rounded w-full"
            >
              <option value="">Select Type</option>
              <option value="characters">Characters</option>
              <option value="journal">Journal</option>
              <option value="followers">Followers</option>
              <option value="books">Books</option>
              <option value="wips">WIPs</option>
            </select>
          </div>
        ) : (
          <div className="w-full text-sm text-gray-700">
            <h3 className="font-semibold mb-2">
              Top 10 <strong>{subtype}</strong>
            </h3>
            {loading ? (
              <div className="text-gray-500 italic">Loading...</div>
            ) : entries.length > 0 ? (
              <ul className="text-sm space-y-1">
                {entries.map((entry) => (
                  <li key={entry.id}>
                    <a
                      href={entry.purchaseLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {entry.title}
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="text-gray-500 italic">
                (coming soon)
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TypeTile;
